import Vue from 'vue';
import axios from 'axios';

export default function checkManagerAccess ({ to, from, next, store }) {
  let user = store.getters.getLoginInProfile; // Declare user variable outside
  if (!user) {
    axios({
      method: "get",
      params: {
        user_id: store.getters.getUser.uuid,
        company_id: store.getters.getSelectedCompany.id
      },
      url: process.env.API_URL + 'api/get-employee-profile',
      headers: {
        'Authorization' : 'Bearer ' + store.getters.getUser.accessToken.token,
        'Device-Type'   : 'web',
        'Accept': 'application/json',
        'Content-Type'  : 'application/json'
      }
    }).then(res => {
      if (res.data.status == 200) {
        // Update user variable inside the Promise callback
        user = res.data.result[0];

        store.commit('setLoginInProfile', user);
        proceed(user);
      }
    }).catch(error => {
      // Handle error
      console.error("Error fetching user profile:", error);
      next(); // Proceed regardless of error
    });
  } else {
    proceed(user);
  }

  function proceed(user) {
    if (user && (user.type === 'MANAGER' || (user.type === 'EMPLOYEE' && user.managerAccess === 'yes'))) {
      return next();
    } else {
      return next({
        name: 'pageNotFound',
        params: { errorCode: 403 },
      });
    }
  }
}




